import { render, staticRenderFns } from "./GiftCode.vue?vue&type=template&id=1a5d21fe&scoped=true"
import script from "./GiftCode.vue?vue&type=script&lang=js"
export * from "./GiftCode.vue?vue&type=script&lang=js"
import style0 from "./GiftCode.vue?vue&type=style&index=0&id=1a5d21fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d21fe",
  null
  
)

export default component.exports